import React, { useEffect, useState } from 'react';
import { styled } from '@mui/system';
import CollapsibleFilter from './CollapsibleFilter';
import InfluencerMinDetails from './InfluencerMinDetails';
import { Autocomplete, Avatar, Button, Checkbox, CircularProgress, IconButton, InputBase, Menu, MenuItem, Modal, Paper, Slide, TextField, Tooltip } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { useTheme, alpha } from '@mui/material/styles';
import AddIcon from '@mui/icons-material/Add';
import { Box, Chip, Grid } from '@mui/material';
import Typography from '@mui/material/Typography';
import DiscoveryNoResults from "../assets/discoveryNoResults.png"
import SearchIcon from '@mui/icons-material/Search';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';

import BasicAccordion from './AccordianFilter';
import OpenInFullOutlinedIcon from '@mui/icons-material/OpenInFullOutlined';
import ClearIcon from '@mui/icons-material/Clear';
import auth from '../api/firebase.js';
import { onAuthStateChanged, onIdTokenChanged } from "firebase/auth";
import { useLocation, useNavigate } from "react-router-dom";

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Pagination from '@mui/material/Pagination';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import InfoIcon from '@mui/icons-material/Info';
import { Mixpanel } from "../mixpanel/mixpanel.js";
import SavedFilters from './SavedFilters';
import DisplayListsDiscovery from './DisplayListsDiscovery.jsx';

const categoryDisplay = "block"

const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
    minHeight: 60,
    maxHeight: 100,
    '&.Mui-expanded': {
        minHeight: 30,
        maxHeight: 130,
    },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

function getStyles(name, personName, theme) {
    return {
        fontWeight:
            personName.indexOf(name) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
    };
}

function Discovery(props) {


    const userData = props.userData;
    var showDashboard = props.showDashboard;

    const lineStyles = {
        position: "fixed",
        height: "100vh",
        top: 0,
        bottom: 0,
        left: '25%',
        width: '1px',
        backgroundColor: '#C4C4C4', // Adjust the line color as needed
    };

    // number of influencers
    const l = 20;
    const rows = Math.ceil(l / 2); // Calculate the number of rows needed
    // const influencerIndices = Array.from({ length: l }, (_, index) => index); // Generate an array of indices

    const gridContainerStyles = {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr', // Two columns
        // gridTemplateRows: `repeat(${rows}, 1fr)`, // Number of rows based on l
        gap: "10px",
    };

    const theme = useTheme();

    const j = 8;
    // const filters = ["Followers", "Categories", "Engagement", "Age", "Gender", "Region", "Brands worked with", "Video Views"]
    const filters = ["Followers", "Categories", "Engagement", "Gender", "Brands worked with", "Video Views", "Price", "Remove Viewed Influencers", "City"]
    //     Followers: 100-5k 5k-20k 20-100k 100k+
    // Eng. : 0-2 2-5 5+
    // Views: 0-5k 5k-30k 30k-150k 150k+
    // {"fashion", "beauty", "blogger", "lifestyle", "skincare", "haircare", "travel", "food", "fitness", "parenting", "technology", "gaming", "business", "finance", "art", 
    // "entertainment", "pets", "education", "music"}
    const filterValues = [
        // ['0 - 10K', '10K - 100K', '100K +'],
        ['0 - 10K', '10K - 30K', '30K - 100K', '100K +'],
        ["fashion", "beauty", "blogger", "lifestyle", "skincare", "haircare", "travel", "food", "fitness", "parenting", "technology", "gaming", "business", "finance", "art", "entertainment", "pets", "education", "music"],
        ["0-2%", "2-5%", "5% +"],
        // ["0-17", "18-25", "26-35", "35+"],
        ["male", "female"],
        // ["Delhi", "Goa", "Mumbai"],
        ['82e.official', '_amounee_', '_huemn', '_skivia_', '_vedikam', 'a.la.modebyakanksha', 'aachho', 'aanchalsayal', 'aarahealth', 'aarkeritukumar', 'aashirvaad', 'abhishti', 'accessorizeindiaofficial', 'adderyfashionhouse', 'adidasindia', 'adorebypriyanka', 'aegteofficial', 'atherenergy', 'ajiolife', 'akashidesignerstudio', 'akivasuperfoods', 'akshayakalpa', 'alantrumanofficial', 'alayabystage3', 'allaboutyou', 'allensollyindia', 'alpinohealthfoods', 'alps_goodness', 'amagbeauty', 'amala.earth', 'amamajewels', 'amanteindia', 'amazfitindia', 'amazondotin', 'amazonfashionin', 'amazonhomeindia', 'amazonkarigar', 'amazonlaunchpadin', 'ambraneindia', 'amd.india', 'americaneagleindia', 'amrapalijewels', 'amtouristerin', 'anastasiabeverlyhills_india', 'andamenlife', 'aniclothing.in', 'anomalyhaircare', 'anveshan.farms', 'anveyaliving', 'apollo_24x7', 'aptronixindia', 'aqualens.in', 'aqualogica.in', 'arata.in', 'archallery', 'ariel.india', 'armanibeauty', 'aromamagicindia', 'arpitamehtaofficial', 'arrow_1851', 'asabeautyindia', 'asalabusandeep', 'ashbabotanics', 'asianfootwears', 'asianpaints', 'asicsindia', 'asusindia', 'atticsalt___', 'aurelia_womenswear', 'autumnlaneofficial', 'axe_india', 'ayouthveda', 'ayuga.in', 'azafashions', 'azahcare', 'babyhug', 'bacca_bucci', 'bachoomotors', 'baesic_world', 'bakingo_official', 'banno.swagger', 'bareanatomy.official', 'barebodyofficial', 'baromarket', 'bata.india', 'bathandbodyworksindia', 'bbgears', 'bbluntindia', 'be.bodywise', 'be_ilana', 'beardo.official', 'beautybarnindia', 'beautypeoplecosmeticsindia', 'bechicbysnehsandhu', 'beglamrs', 'belifindia', 'bellavita.official', 'bellavitaluxuryofficial', 'bellofox', 'beloracosmetics', 'beminimalist__', 'benefitindia', 'bergerpaintsindia', 'berrylush_com', 'bespoke_ozels', 'bevzilla_official', 'bewakoofofficial', 'beyondfollow', 'bhumikasharmaofficial', 'bibaindia', 'bigbasketcom', 'bigmuscles_nutrition', 'bingo_snacks', 'biotique_world', 'birdsofparadyes', 'biryanibykilo', 'blenditrawbeauty', 'blinglane', 'blueheavencosmetics', 'bluenectar_ayurved', 'bluetokaicoffee', 'bluetribeofficial', 'blurindia', 'bn.parfums', 'boat.nirvana', 'bobbibrownindia', 'boddessbeauty', 'bodicebodice', 'bodycupid', 'bodywise.shop', 'bombayshavingcompany', 'bombayshirts', 'bonkers.man', 'bonorganik', 'borosilandyou', 'boujeebeautyin', 'boultaudio', 'bounceincindia', 'brainsmithindia', 'braunbeauty_in', 'brillareindia', 'britannia.industries', 'brustro_official', 'bryanandcandy', 'bubblefarmindia', 'buddsbuddy', 'budsandberries.in', 'bumble_india', 'bummer.in', 'bunaai', 'burger.bae', 'butterfly_beauty_bliss', 'callosangeles_', 'campusshoes', 'canonindia_official', 'caratlane', 'carltonlondonindia', 'casio.india', 'catch_foods', 'caterpillarinc', 'celioindia', 'centralandme', 'centroshoesindia', 'cetaphil_india', 'chaayos', 'chaisuttabarindia', 'chamborgeneva', 'charactercosmeticsindia', 'charmacymilano', 'chemistatplay.official', 'chhapa_gj8', 'chicnutrix', 'chiquestudio', 'chkokko', 'chola_the_label', 'chumbak', 'ciel_skincare', 'citroen_india', 'clinique_in', 'clovia_fashions', 'clubmahindra', 'colocalchocolates', 'coloressenceofficial', 'converse.india', 'cordeliacruises', 'countrybeancoffee', 'countrydelightnatural', 'coveritup', 'coverstoryfsl', 'cred_club', 'crocsindia', 'croma.retail', 'crossbeatsind', 'cuddlesforcubs', 'cultsportindia', 'curlcure.in', 'daburindialtd', 'dailyobjects_official', 'damenschofficial', 'danielklein_india', 'daughterearthofficial', 'dazllercosmetics', 'decathlonsportsindia', 'deconstruct_skincare', 'deeprooted.co', 'dennislingo.official', 'denverformen', 'desiredesignstudio_', 'dettol.india', 'devnaagri', 'deyga_organics', 'diamondlady.in', 'digitekofficial', 'discover.pilgrim', 'disguisecosmetics', 'docsneakers', 'doeraaindia', 'doggiedabbas', 'dominabypeesafe', 'dominos_india', 'dorcoindia', 'doritosindia', 'dotandkey.skincare', 'dove', 'dressbarn', 'dressfolk', 'drinkslaycoffee', 'dromenco', 'drsheths', 'drzya_ridhisuri', 'durex.india', 'duroflexworld', 'dyou.co', 'dyson_india', 'easemytrip', 'eastern_in', 'eatsurenow', 'eclatsuperior', 'ecofynd', 'edamamma', 'ejaazcouture', 'ekamonline', 'ekayabanaras', 'ekbyekta', 'elegant_fashion_way', 'elevarsports_official', 'ellementryhome', 'emprallofficial', 'enamorindia', 'ennbeautyindia', 'enrichbeauty', 'epigamia.official', 'eridani.in', 'esteelauder', 'esteelauderin', 'estiecouture', 'etchcraftemporium.in', 'ethoswatches', 'etudeindia', 'everestspices', 'everstylishcom', 'everyuthnaturals', 'evotique', 'ewayoung', 'exotic_collections', 'explurger.app', 'eyewearlabs', 'faasos', 'faballey', 'fabellechocolates', 'fabindiahome', 'fabindiaofficial', 'fable.street', 'fabneststudio', 'facescanada', 'faebeautyofficial', 'fairplay_india', 'faithandpatience_shop', 'farmleyin', 'fashionfloorindia', 'fashor_com', 'fastandup_india', 'fayonkids', 'fclskincare', 'femella', 'fingersindia', 'fireboltt_', 'firstcryindia', 'fixderma.skincare', 'fizzygoblet', 'flickacosmetics', 'flipkart', 'flipkartlifestyle', 'foodhallindia', 'foodstrong.co', 'forever21_in', 'forever52india', 'forevernew_india', 'foxtaleskin', 'freakinsindia', 'freedomtreehome', 'fugazeeinc', 'fuzzycurls_', 'garminfitness', 'garnierindia', 'gauriandnainika', 'getbeatxp', 'getketchofficial', 'getonecardin', 'getsmytten', 'gharsoaps', 'giva.co', 'gkhairindia', 'globusfashion', 'go_noise', 'gocolors', 'good_vibes.in', 'gooddot', 'goproindia', 'gritzoindia', 'gshock_in', 'guardiangnc', 'gubb_world', 'gush.beauty', 'gymxapparel', 'hairlove_india', 'hamleys_india', 'hammerlifestyle_', 'happy.wagon', 'harleydavidson_india', 'hausandkinder', 'havells__india', 'headsupfortails', 'healthifyme', 'healthkart', 'heimish_cosmetic', 'helioswatches', 'hellonyumi', 'herbtantra', 'herocosmetics', 'heromotocorp', 'hersheinbox', 'heynnnow', 'hi_life_exhibition', 'highlander_india', 'himairag', 'himalaya.babycare', 'himalaya_facecare', 'himalayapersonalcare', 'hisugarpop', 'hkbasics', 'hkvitals', 'hm', 'hobo.video', 'hokmakeup', 'hopscotch.in', 'horraluxury', 'houseofchikankari.in', 'houseofdoro', 'houseoffett', 'houseofkari.in', 'houseofmasaba', 'houseoftaamara', 'hrxbrand', 'hyundaiindia', 'ibacosmetics', 'idaho_o', 'ikaiasai', 'ikkai.beauty', 'ikkivi', 'ikonic_professional', 'iloveunloc', 'imagimake', 'in.avon', 'inaya_accessories', 'inc5official', 'indi_luxe', 'indiabikeweek', 'indiandecorideas', 'indianweddingoutfits', 'indiatrend', 'indulgeo.essentials', 'indya', 'innisfreeindia', 'insightcosmetic', 'inskybags', 'insta360', 'instaxindia', 'instorefashions', 'iqooind', 'itsallabouthome_', 'izfworld', 'jackjonesindia', 'jadeforestin', 'jaguar_india', 'jaipurgems', 'jaipuriadaah', 'jaipurkurti', 'jaipurrugs', 'janasyaclothing', 'jaquarindia', 'jaqulineusa', 'jaypore', 'jblindia', 'jeevansathi_com', 'jiomartofficial', 'jisorajaipur', 'jockeyindia', 'jokerandwitch', 'josalukkas', 'jovifashion', 'joyalukkas', 'jqrsport', 'juicy_chemistry', 'justherbsindia', 'kaleidosmakeup', 'kalkifashion', 'kalyanjewellers_official', 'kamaayurvedaindia', 'kameez.co_', 'kapiva_official', 'karagiri_ethnic', 'kaybykatrina', 'kazowoman', 'kerastase_official', 'kharakapas', 'kidbea', 'kiehlsindia', 'kimirica.shop', 'kirobeauty', 'kitkatindia', 'klingaru', 'klotthe', 'kohler_india', 'kraftedwithhappiness', 'kralife_', 'kreeva_lifestyles', 'kushalsfashionjewellery', 'kwabeyfashion', 'label_deepikanagpal', 'labelishnya', 'labelnityabajaj', 'labelsanyagulati', 'labelsaras', 'lagirlindia', 'lakmeindia', 'lakmesalon', 'lamiorofficial', 'lavanyathelabel', 'lavieworld', 'lays_india', 'lazygardener.in', 'leaclothingco', 'leaf.studios', 'leejeansindia', 'lenskart', 'letscurlupdotcom', 'letsdressup.in', 'letsgettaggd', 'letspurplle', 'levis_in', 'libasindia', 'licious_foods', 'lifestylestores', 'lili_origin', 'limeroad', 'limese_connect', 'linoperros', 'liveaastey', 'livon', 'liyokki', 'londonprimeindia', 'loneridergear', 'lorealindia', 'lorealpro', 'lotus365world', 'lotus_herbals', 'lotus_organicsplus', 'lotusbotanicalsofficial', 'louisphilippeindia', 'lovebeautyandplanet', 'lovebeautyandplanet_in', 'lovechildbymasaba', 'lovecolorbar', 'loveearth_handmade', 'loverecode', 'lovetobag', 'luluandskyofficial', 'luvlap.in', 'lykkeinofficial', 'maccaron_beauty', 'maccosmeticsindia', 'madamefashions', 'madoverdonuts', 'maggiindia', 'mahesh_notandass', 'mahindra.scorpio.official', 'maishabyesha', 'makeo_toothsialigners', 'makeuprevolutionindia', 'mamaearth.in', 'man.matters', 'manetainstore', 'manishmalhotrabeauty', 'manyavar', 'marketcitykurla', 'marksandspencerindia', 'marutisuzukiofficial', 'masterchow.in', 'matrixindia_lnc', 'mattlookcosmetic', 'maxfashionindia', 'maybelline_ind', 'mcaffeineofficial', 'mcdonalds_india', 'mcdonaldsinindia', 'meemeein', 'meeshoapp', 'melangebox', 'melorra_com', 'mensxpshop', 'mesmerizeindia', 'mgmotorin', 'miabytanishq', 'milagro.beauty', 'milapcosmetics', 'miniklub.in', 'minisoindia', 'mirraw', 'mishruofficial', 'missa_more_clothing', 'missclairecosmetic', 'mivi', 'moheyfashion', 'mojindia', 'mokobara', 'momspressomymoney', 'momzjoy', 'monkandmei', 'monkinz', 'monrowshoes', 'mothercare_india', 'mothersparsh', 'motorolain', 'mototechgear', 'mumusoindia', 'muradskincare', 'muscleblaze', 'muscleblazefit', 'mybabybabbles', 'mybabychakra', 'myblissclub', 'mycarmesi', 'mycosiq', 'myfitness', 'myglamm', 'mylo_baby_', 'myntra', 'myntrabeauty', 'myntrafwd', 'mynykaa', 'myplixlife', 'myproteinin', 'myskinq', 'mywishcare', 'myzudio', 'n.y.bae', 'nakhrewaali', 'nallisilksarees', 'namyaaskincare', 'nathabit.in', 'naturalicecream', 'naturesbasket', 'nautica.in', 'needledust', 'neemansofficial', 'neemli', 'neofaaofficial', 'nestasia.in', 'nesterrahomedecor', 'neutrogena', 'newme.asia', 'neyahbeauty', 'nikenyc', 'nilkamal_ltd', 'nivea', 'niveaindia', 'noberodotcom', 'nonasties', 'nuawoman', 'nurserylive_', 'nurturinggreen', 'nutrabay', 'nykaabeauty', 'nykaafashion', 'nykaaman', 'nykaapro', 'nykaawellness', 'nykdbynykaa', 'nynm.in', 'nyxcosmetics_in', 'o3plusworld', 'oceedeeshoes', 'oceglowindia', 'odette_style', 'odhniworld', 'offduty.india', 'officialswissbeauty', 'officialzivame', 'oh_ind', 'olayindia', 'oldmarigoldindia', 'onehairstopindia', 'onlyindia', 'opensecretsnacks', 'oppoindia', 'optimumnutri_in', 'ordinaree.in', 'oreo.india', 'organicindiaofficial', 'orrajewellery', 'our.littlejoys', 'outhousejewellery', 'ovenstory', 'ozivanutrition', 'paccosmetic', 'pahadilocal', 'palmonas_official', 'pampersindia', 'pantaloonsfashion', 'paperboatdrinks', 'parkavenue_grooming', 'parkavenuestyleup', 'parleproducts', 'parogoodearth', 'pausefashion.in', 'pc_jeweller', 'pebbleofficial', 'pedigree_india', 'peeperlyindia', 'peesafe', 'pepejeansindia', 'pepperfry_official', 'pepplay', 'pepsiindia', 'perforaofficial', 'performaxactivewear', 'perniaspopupshop', 'personaltouchskincare', 'philipsindia', 'picchika', 'pinklayindia', 'pintola.in', 'pipabella', 'pizzahut_india', 'platinumdaysoflove', 'playnwinbookofficial', 'plumbodylovin', 'plumgoodness', 'plushforher', 'pngjewellers', 'polagoclothing', 'pomcha_jaipur', 'pondsindia', 'poonamskaurture', 'portronics.india', 'poshmarkindia', 'potsandpans.in', 'power_gummies', 'powerlookofficial', 'praush.beauty', 'prerto', 'priyaasijewelry', 'prolixr', 'ptronindia', 'pumaindia', 'purearth', 'purebypriyanka', 'puresenseworld', 'qraamen', 'quenchbotanics', 'rabitatinc', 'ragecoffee_', 'raidagears', 'raniwala1881', 'rareism_in', 'rarerabbit_in', 'rasluxuryoils', 'ravelcare', 'rdindia_', 'reachedmars', 'realmeindia', 'realmenarzoin', 'redtapeindia', 'redwolfdotin', 'reequil', 'reetiarneja', 'reliancejewels', 'reliancetrends', 'remymartin', 'reneeofficial', 'revit_official', 'rforrabbitbaby', 'ridhimabhasinofficial', 'ritebite_maxprotein', 'ritikamirchandani', 'ritualistic.in', 'riyoherbs', 'roposolove', 'roukabysreejithjeevan', 'royalchallengechoosebold', 'royalenfieldlifestyle', 'royale_touche', 'rstaichi.official', 'rubans.in', 'rubys.organics', 'rustorangedotcom', 'rynoxgear', 'saadaadesigns', 'saaki.world', 'sachdeva.ritika', 'sadhev', 'sajke.in', 'samandmarshall', 'samsung', 'samsungindia', 'samsungmobile', 'samsungwithgalaxy', 'samyakksarees', 'sanfeindia', 'sanskrutihomes', 'saritahanda', 'sarvayogastudios', 'sassafrasindia', 'sassykidsindia', 'satsportofficial', 'satyapaulindia', 'saundhindia', 'scholarestore', 'schwarzkopfin', 'sebamedindia', 'secrethairoil', 'secrettemptationofficial', 'seemattitextiles', 'selectedindia', 'sephora_india', 'serycosmetics', 'setuindia', 'sfmomsmagic', 'shabad_trends', 'shayagrams', 'shein_in', 'shoethatfitsyou_', 'shop.tinted', 'shopheymissy', 'shoplittlebox_india', 'shoplune', 'shoppers_stop', 'shopsy_app', 'shumeetoys', 'shyawayshop', 'simpleskincareindia', 'simplynam.beauty', 'sironahygiene', 'skechersindia', 'skechersperformanceindia', 'skinbae.in', 'skinkraftofficial', 'skinn_titan', 'skippiicepops', 'sleepycat.in', 'sleepyowlcoffee', 'slurrpfarm', 'smashboxindia', 'smoorchocolates', 'snackible', 'snapdeal', 'snapdragonofficial', 'snitch.co.in', 'sochstories', 'socksoho', 'softsens', 'solacegears', 'solethreads', 'sonataindia', 'soulslings', 'soultree.in', 'sparxgoforit', 'spiritanimal.in', 'sprite_india', 'srstore09', 'ssbeauty', 'stacfinejewellery', 'stalkbuylove', 'starstruckbysl', 'stayfreeindia', 'stayneu', 'stayquirky.in', 'stbotanica.india', 'storiafoods', 'storyathomeindia', 'streetstylestoreofficial', 'styched.in', 'stylebyand', 'stylestryofficial', 'subkocoffee', 'sublimelifeofficial', 'suganda.co', 'sugarcandyindia', 'sugarmiddleeast', 'sula_vineyards', 'sunfeastdarkfantasy', 'sunita_shekhawat_jaipur', 'superbottoms', 'superdryindia', 'supervek', 'suroskiebeauty', 'suta_bombay', 'sweettruth.india', 'swiggy_instamart', 'swiggyindia', 'swtantraofficial', 'tagg_digital', 'taneira_sarees', 'tanishqjewellery', 'taruntahiliani', 'tashijaipur', 'tatacliq', 'tatacliqluxury', 'tatacliqpalette', 'tatasoulfull', 'tbz.theoriginal', 'teatrunk', 'tecnomobileindia', 'teejhindia', 'tegofit', 'the_eatfit', 'thealchemicbeauty', 'theancestrystore', 'theaugustcompany', 'theayurvedaco', 'thebeautycoindia', 'thebeautystorebybigbasket', 'thebodyshopindia', 'theboozybutton', 'thebtclub', 'thecaistore', 'thedashanddot', 'thedecorkart', 'thedermacoindia', 'thedivinetrendz', 'theearthrhythm', 'thefaceshopindia_official', 'thegarnierman', 'thegreensnackco', 'thehandicraftian', 'thehosteller', 'thehyugalife', 'theindusvalley', 'thejodilife', 'thejuneshopindia', 'thekoskii', 'thelabellife', 'thelinenclub', 'theloom.in', 'themancompany', 'themessycornerr', 'themohalife', 'themomsco', 'thenaturalwash', 'theobromapatisserie', 'thepantproject', 'thephylife', 'theplatedproject', 'thepurpleturtles', 'theputchi', 'theroadsterlife', 'thesassbar', 'thesilverdeneluxury', 'theskinstore.in', 'thesleepcompany_official', 'thesouledstore', 'thetribeconcepts', 'theustraa', 'thewellnessshopindia', 'thewholetruthfoods', 'thewomanscompany', 'thinkitchen', 'thrillophilia', 'thrivecotalks', 'thumsupofficial', 'tinder_india', 'tirabeauty', 'titanwatchesindia', 'tjoritreasures', 'toesmithofficial', 'tokyo_talkies', 'toofacedlovesindia', 'tooyumm', 'toycra', 'traya.health', 'trenbee_', 'tresemmeindia', 'tribebyamrapali', 'triumphlingerie', 'true.elements', 'truebrowns', 'truhairandskin', 'truvitals.in', 'trysugar', 'ttkprestige', 'turaturi', 'turms_intelligent_apparels', 'twentydresses', 'twobrothersorganicfarmsindia', 'tyaanijewellery', 'typsybeauty', 'ubon_official', 'ugaoo', 'ultrahumanhq', 'unacademy', 'underarmourind', 'uneekindia', 'upakarna', 'uptownie101', 'urbancompany', 'urbanic_in', 'urbanladder', 'urbanmonkeyindia', 'urbanyog_official', 'urbnworld', 'vahdamindia', 'vandykeindia', 'vanheusenind', 'vanitywagon', 'varanga_official', 'varunbahlcouture', 'vaselineindia', 'vedixofficial', 'vegabeauty', 'vegnonveg', 'venusgillette_in', 'viaterragear', 'victoriassecretindia', 'vijaysalesofficial', 'villainlife.official', 'vilvah_', 'virgio_in', 'vishudh_life', 'vivo_india', 'vlccin', 'vlccpersonalcare', 'volvocarsin', 'voyageeyewear', 'voylla', 'vuoriclothing', 'wabisabistyl', 'wakefitco', 'wallmantra', 'wareinnovations', 'wearyouropinion', 'wellbeing.nutrition', 'westelm_india', 'westsidestores', 'wetnwildindia', 'wforwoman', 'whisperindia', 'whysobluelove', 'wild_ferns_india', 'wildstoneofficial', 'winfair247', 'wingreensfarms', 'winston_india_', 'winstonindia.official', 'wolf777exchange', 'wondercheflife', 'woovlyapp', 'wowlifescienceindia', 'wowmomos', 'wowskinscienceindia', 'xctasy.co', 'xiaomiindia', 'xyxxcrew', 'yam.india', 'yogabars.in', 'yuftaindia', 'zaamo.official', 'zara', 'zerokaata', 'zingavita', 'zinklondon', 'zomato', 'zooomberg', 'zoukonline', 'zwendedesign', 'zymratwear'],
        ["0-5K", "5K-30K", "30K-150K", "150K +"],
        ["< ₹ 2K", "₹ 2K - ₹ 5K", "₹ 5K - ₹ 20K", "₹ 20K +"],
        ["Yes"],
        ["Gurgaon", "Gurugram", "Delhi", "Mumbai", "Bangalore", "Chennai", "Kolkata", "Hyderabad", "Goa", "Pune", "Ahmedabad", "Jaipur", "Chandigarh", "Lucknow"]
    ];

    const [followers, setFollowers] = React.useState([]);
    const [followersCategory, setFollowersCategory] = React.useState([]);

    const [categories, setCategories] = React.useState([]);

    const [engagement, setEngagement] = React.useState([]);
    const [engagementCategory, setEngagementCategory] = React.useState([]);

    const [age, setAge] = React.useState([]);
    const [ageCategory, setAgeCategory] = React.useState([]);

    const [gender, setGender] = React.useState([]);

    const [region, setRegion] = React.useState([]);

    const [brandsWorked, setBrandsWorked] = React.useState([]);

    const [videoViews, setVideoViews] = React.useState([]);
    const [videoViewsCategory, setVideoViewsCategory] = React.useState([]);

    const [influencerCost, setInfluencerCost] = useState([]);
    const [influencerCostCategory, setInfluencerCostCategory] = useState([]);

    const [removeViewed, setRemoveViewed] = useState([]);
    const [city, setCity] = useState([]);
    const [isYoutuber, setIsYoutuber] = useState([])

    // const filterKeys = [followers, categories, engagement, age, gender, region, brandsWorked, videoViews]
    const filterKeys = [followers, categories, engagement, gender, brandsWorked, videoViews, influencerCost, removeViewed, city]

    // function callDiscoveryApi(i, arr) {
    //     const newIndices = arr.map((value) => {

    //         const foundIndex = filterValues[i].findIndex(item => item === value);

    //         return foundIndex;
    //     });

    //     if (i == 0) { setFollowersCategory(newIndices); }
    //     if (i == 2) { setEngagementCategory(newIndices); }
    //     if (i == 5) { setVideoViewsCategory(newIndices); }
    // }


    // function handleChange2(filterName, value) {
    //     if (filterName == filters[0]) { callDiscoveryApi(0, value) }
    //     if (filterName == filters[2]) { callDiscoveryApi(2, value) }
    //     if (filterName == filters[5]) { callDiscoveryApi(5, value) }
    // }

    var clearFilter = "none";
    var viewSaveFilter = "block";
    var displayRemoveViewed = true;
    if (followers.length > 0 || categories.length > 0 || engagement.length > 0 || gender.length > 0 || brandsWorked.length > 0 || videoViews.length > 0 || influencerCost.length > 0 || removeViewed.length > 0 || city.length > 0) { clearFilter = "block"; viewSaveFilter = "none" }
    if (followers.length + categories.length + engagement.length + gender.length + brandsWorked.length + videoViews.length + influencerCost.length + city.length > 1) { displayRemoveViewed = false; }

    const [expandedAccordions, setExpandedAccordions] = useState(new Array(filters.length).fill(false));

    const handleAccordionExpand = (index) => {
        const updatedExpandedAccordions = new Array(filters.length).fill(false);
        updatedExpandedAccordions[index] = !expandedAccordions[index];
        setExpandedAccordions(updatedExpandedAccordions);
    };

    const handleClearFilter = async () => {
        setFollowers([]);
        // setFollowersCategory([]);
        setCategories([]);
        setEngagement([]);
        // setEngagementCategory([]);
        // setAge([]);
        setGender([]);
        // setRegion([]);
        setBrandsWorked([]);
        setVideoViews([]);
        // setVideoViewsCategory([]);
        setInfluencerCost([]);
        setRemoveViewed([]);
        setCity([]);
        setIsYoutuber([])
        setPage(1)

        setExpandedAccordions(new Array(filters.length).fill(false));
        clearFilter = "none";

        setIsLoading(true)
        let discoveryApiData = {
            filters: {
                "followersCategory": [],
                "category": [],
                "engagementCategory": [],
                "gender": [],
                "collabBrands": [],
                "viewsCategory": [],
                "costCategory": [],
                "city": [],
                "isYoutuber": []
            },
            removeViewed: [],
            page: 1
        }

        window.localStorage.setItem('filters', JSON.stringify(discoveryApiData));

        const token2 = await userData.getIdToken()

        let discoveryApiOptions = {
            method: 'POST',
            body: JSON.stringify(discoveryApiData),
            headers: new Headers({
                'Authorization': `Bearer ${token2}`,
                'Content-Type': "application/json"
            })
        }

        fetch(process.env.REACT_APP_API_ADDRESS + '/api/influencer_discovery_copy/', discoveryApiOptions)
            .then(result => result.json())
            .then(body => { decodeInfluencer(body["influencers"]); setTotalDocs(body["totalDocs"]) });
    };

    class Influencer {
        constructor(username, followers, mediaCount, gender, fullName, collabBrands, category, avgEngagement, avgViews, state, website, hasCostData, estimatedCost, hasEimuId, eimuId) {
            this.username = username;
            this.followers = followers;
            this.mediaCount = mediaCount;
            this.gender = gender;
            this.fullName = fullName;
            this.collabBrands = collabBrands;
            this.category = category;
            this.avgEngagement = avgEngagement;
            this.avgViews = avgViews;
            this.state = state;
            this.website = website;
            this.hasCostData = hasCostData;
            this.estimatedCost = estimatedCost;
            this.hasEimuId = hasEimuId;
            this.eimuId = eimuId;
        }
    }

    function decodeInfluencer(jsonPayload) {

        var influencers_list = jsonPayload.map(influencer => {
            return new Influencer(influencer.username, influencer.followers, influencer.mediaCount, influencer.gender, influencer.fullName, influencer.collabBrands, influencer.category, influencer.avgEngagement, influencer.avgViews, influencer.state, influencer.website, influencer.hasCostData, influencer.estimatedCost, influencer.hasEimuId, influencer.eimuId);
        });

        setInfluencers(influencers_list);
        setIsLoading(false);
    }

    const [page, setPage] = React.useState(1);
    const handleChange = (event, value) => {
        setPage(value);
        if (value > (influencers.length) / 100) {
            setIsLoading(true);
            searchInfluencers(value, true);
        }
    };

    const [influencers, setInfluencers] = useState([]);

    const [totalDocs, setTotalDocs] = useState(0)

    const [savedFilters, setSavedFilters] = useState(null)

    // console.log("SAVED FILTERS APPLIED")
    // console.log(savedFilters)



    async function searchInfluencers(pageNo, applyButtonClicked) {
        let discoveryApiData = {};
        discoveryApiData = {
            filters: {
                "followersCategory": followers,
                "category": categories,
                "engagementCategory": engagement,
                // "ageCategory": ageCategory,
                "gender": gender,
                // "state": region,
                "collabBrands": brandsWorked,
                "viewsCategory": videoViews,
                "costCategory": influencerCost,
                "city": city,
                "isYoutuber": isYoutuber
            },
            removeViewed: removeViewed,
            page: pageNo
        }

        window.localStorage.setItem('filters', JSON.stringify(discoveryApiData));

        setPage(pageNo);

        // if (applyButtonClicked) {
        //     Mixpanel.identify(userData.email);
        //     Mixpanel.track('Filters Applied', { discoveryApiData });
        // }
        Mixpanel.identify(userData.email);
        Mixpanel.track('Filters Applied', { discoveryApiData });

        const token2 = await userData.getIdToken()

        let discoveryApiOptions = {
            method: 'POST',
            body: JSON.stringify(discoveryApiData),
            headers: new Headers({
                'Authorization': `Bearer ${token2}`,
                'Content-Type': "application/json"
            })
        }

        // console.log("DISCOVERY API DATA")
        // console.log(discoveryApiData);

        fetch(process.env.REACT_APP_API_ADDRESS + '/api/influencer_discovery_copy/', discoveryApiOptions)
            .then(result => result.json())
            .then(body => { decodeInfluencer(body["influencers"]); setTotalDocs(body["totalDocs"]) });
    };

    const [isFirstLoad, setIsFirstLoad] = useState(true)

    const [checked, setChecked] = useState([]);
    const [checkedMap, setCheckedMap] = useState(new Map());

    useEffect(() => {
        if (isFirstLoad == false) {
            setIsLoading(true)
            searchInfluencers(1, false)
        }
        setCheckedAll(false);
        setCheckedMap(new Map());
        setChecked([])
    }, [followers, categories, engagement, gender, brandsWorked, videoViews, influencerCost, removeViewed, city, isYoutuber])

    useEffect(() => {
        // setIsLoading(true)
        if (savedFilters != null) {
            setFollowers(savedFilters["filters"]["followersCategory"]);
            setCategories(savedFilters["filters"]["category"]);
            setEngagement(savedFilters["filters"]["engagementCategory"]);
            setGender(savedFilters["filters"]["gender"]);
            setBrandsWorked(savedFilters["filters"]["collabBrands"]);
            setVideoViews(savedFilters["filters"]["viewsCategory"]);
            setInfluencerCost(savedFilters["filters"]["costCategory"]);
            setRemoveViewed(savedFilters["removeViewed"]);
            setCity(savedFilters["filters"]["city"]);
            setPage(1)
            handleCloseSavedFilters()
        }
    }, [savedFilters])


    useEffect(() => {
        const prevFilters = JSON.parse(window.localStorage.getItem('filters'));
        if (prevFilters) {
            setSavedFilters(prevFilters);
        } else if (isFirstLoad) {
            setIsLoading(true)
            searchInfluencers(1, false)
        }
        setIsFirstLoad(false)
    }, []);


    const [isLoading, setIsLoading] = useState(false)

    const handleButtonClick = (buttonValue, filterKey) => {

        const stateArray = getFilterStateArray(filterKey);

        if (stateArray.includes(buttonValue)) {
            stateArray.splice(stateArray.indexOf(buttonValue), 1);
            setFilterStateArray(filterKey, stateArray);
        } else {
            setFilterStateArray(filterKey, [...stateArray, buttonValue]);
        }
    };

    var filterLimits = [1, 3, 1, 1, 3, 1, 1, 1, 1];

    const getFilterStateArray = (filterKey) => {
        switch (filterKey) {
            case 'Followers':
                return followers;
            case 'Categories':
                return categories;
            case 'Engagement':
                return engagement;
            case 'Gender':
                return gender;
            case 'Brands worked with':
                return brandsWorked;
            case 'Video Views':
                return videoViews
            case 'Price':
                return influencerCost
            case 'Remove Viewed Influencers':
                return removeViewed
            case 'City':
                return city
            default:
                return [];
        }
    };



    const setFilterStateArray = (filterKey, newStateArray) => {
        switch (filterKey) {
            case 'Followers':
                if (followers.length < 1) {
                    setFollowers(newStateArray);
                    // handleChange2(filterKey, newStateArray)
                }
                break;
            case 'Categories':
                if (categories.length < 3) {
                    setCategories(newStateArray);
                }
                break;
            case 'Engagement':
                if (engagement.length < 1) {
                    setEngagement(newStateArray);
                    // handleChange2(filterKey, newStateArray)
                }
                break;
            case 'Gender':
                if (gender.length < 1) {
                    setGender(newStateArray);
                }
                break;
            case 'Brands worked with':
                if (brandsWorked.length < 3) {
                    setBrandsWorked(newStateArray);
                }
                break;
            case 'Video Views':
                if (videoViews.length < 1) {
                    setVideoViews(newStateArray);
                    // handleChange2(filterKey, newStateArray)
                }
                break;
            case 'Price':
                if (influencerCost.length < 1) {
                    setInfluencerCost(newStateArray);
                }
                break;
            case 'Remove Viewed Influencers':
                if (removeViewed.length < 1) {
                    setRemoveViewed(newStateArray);
                }
                break;
            case 'City':
                if (city.length < 1) {
                    setCity(newStateArray);
                }
                break;
            default:
                break;
        }
    };

    function removeSelection(value, filterKeyArray, index) {

        const newArray = filterKeyArray.filter(item => item !== value);

        switch (index) {
            case 0:
                setFollowers(newArray);
                break;
            case 1:
                setCategories(newArray);
                break;
            case 2:
                setEngagement(newArray);
                break;
            case 3:
                setGender(newArray);
                break;
            case 4:
                setBrandsWorked(newArray);
                break;
            case 5:
                setVideoViews(newArray);
                break;
            case 6:
                setInfluencerCost(newArray);
                break;
            case 7:
                setRemoveViewed(newArray);
                break;
            case 8:
                setCity(newArray);
                break;
            default:
                break;
        }
    }

    function handleAutocomplete(value) {

        if (value != null && brandsWorked.length < 3 && !brandsWorked.includes(value)) {
            setBrandsWorked([...brandsWorked, value]);
        }
    }

    var displayPagination = (influencers.length > 0) ? "block" : "none";
    var displayNoPage = (influencers.length > 0) ? "none" : "block";

    const styleInfluencerSearch = {
        position: 'relative',
        transform: 'translate(-50%, -50%)',
        top: '50%',
        left: '50%',
        width: "30%",
        height: "200px",
        bgcolor: 'white',
        boxShadow: 24,
        borderRadius: "20px",
        p: 3,
    };

    const handleCloseDialog = () => {
        console.log("No access")
    };

    const savedFilterStyles = {
        position: 'absolute',
        left: '80%',
        // transform: 'translate(-50%, -50%)',
        width: "20%",
        height: "100%",
        bgcolor: 'background.paper',
        boxShadow: 24,
    };

    const [openSavedFilters, setOpenSavedFilters] = useState(false);
    const handleOpenSavedFilters = () => { setOpenSavedFilters(true); }
    const handleCloseSavedFilters = () => setOpenSavedFilters(false);

    // useEffect(() => {
    //     setIsLoading(true)
    //     searchInfluencersSavedFilters()
    // }, [savedFilters])

    async function searchInfluencersSavedFilters() {
        const token2 = await userData.getIdToken()

        let options = {
            method: 'POST',
            body: JSON.stringify(savedFilters),
            headers: new Headers({
                'Authorization': `Bearer ${token2}`,
                'Content-Type': "application/json"
            })
        }
        fetch(process.env.REACT_APP_API_ADDRESS + '/api/influencer_discovery_copy/', options)
            .then(result => result.json())
            .then(body => { decodeInfluencer(body["influencers"]); setTotalDocs(body["totalDocs"]) });
    }

    const [saveFilterCta, setSaveFilterCta] = useState("Save Filter")

    async function saveAppliedFilters() {
        const token2 = await userData.getIdToken()

        // var rv = (removeViewed.length == 0) ? "No" : removeViewed[0]

        setSaveFilterCta("Saved!")

        var data = {
            filterName: filterName,
            filterValue: {
                filters: {
                    "followersCategory": followers,
                    "category": categories,
                    "engagementCategory": engagement,
                    // "ageCategory": ageCategory,
                    "gender": gender,
                    // "state": region,
                    "collabBrands": brandsWorked,
                    "viewsCategory": videoViews,
                    "costCategory": influencerCost,
                    "city": city
                },
                removeViewed: removeViewed,
                page: page
            }
        }

        let options = {
            method: 'POST',
            body: JSON.stringify(data),
            headers: new Headers({
                'Authorization': `Bearer ${token2}`,
                'Content-Type': "application/json"
            })
        }
        fetch(process.env.REACT_APP_API_ADDRESS + '/api/save_applied_filters/', options)
            .then(result => result.json())
            .then(body => { handleCloseButtonSavedFilters(); setSaveFilterCta("Save Filter") });
    }

    const [openButtonSavedFilters, setOpenButtonSavedFilters] = useState(false);
    const handleOpenButtonSavedFilters = () => { setOpenButtonSavedFilters(true); }
    const handleCloseButtonSavedFilters = () => { setOpenButtonSavedFilters(false); setFilterName("") }

    const [filterName, setFilterName] = useState("")

    const handleFilterName = event => {
        setFilterName(event.target.value);
    };


    const [youtuberStyle, setYoutuberStyle] = useState({ border: "1px solid #C4C4C4", color: "black", borderRadius: "20px", fontSize: "12px" })
    const [clearYouTubeFilter, setClearYouTubeFilter] = useState(false)
    function handleIsYouTuber() {
        if (clearYouTubeFilter == true) {
            setClearYouTubeFilter(false)
            setYoutuberStyle({ border: "1px solid #C4C4C4", color: "black", borderRadius: "20px", fontSize: "12px" })
            setIsYoutuber([])
        } else {
            setClearYouTubeFilter(true)
            setYoutuberStyle({ border: "1px solid #E4F87F", color: "black", borderRadius: "20px", background: "rgb(228, 248, 127, 0.6)", fontSize: "12px" })
            setIsYoutuber([true])
        }
    }


    function handleToggle(value) {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setChecked(newChecked);

        const newCheckedMap = new Map(checkedMap);
        newCheckedMap.set(value.username, !checkedMap.get(value.username));
        setCheckedMap(newCheckedMap);
    };

    const [openList, setOpenList] = useState(false);
    const handleOpenList = () => setOpenList(true);
    const handleCloseList = () => setOpenList(false);


    const [checkedAll, setCheckedAll] = useState(false)
    // const [checkedAllInfluencers, setCheckedAllInfluencers] = useState([])
    function selectAll() {
        setCheckedAll(!checkedAll)
        if (!checkedAll) {
            var currInfluencers = influencers.slice((page - 1) * 100, page * 100)
            setChecked(currInfluencers)

            const newCheckedMap = new Map();

            for (let i = 0; i < currInfluencers.length; i++) {
                newCheckedMap.set(currInfluencers[i].username, true);
            }
            setCheckedMap(newCheckedMap);

        } else {
            setChecked([])
            setCheckedMap(new Map())
        }
    }

    useEffect(() => {
        setCheckedAll(false);
        setCheckedMap(new Map());
        setChecked([])
    }, [page])


    return (
        <div style={{ display: "flex" }}>
            {!showDashboard && <Dialog
                open={true}
                onClose={handleCloseDialog}
                fullWidth={true}
                maxWidth='sm'
            >
                <Box style={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: 'center' }}>
                    <DialogTitle>
                        {"Your free trial has ended."}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText >
                            Please contact us at shubham@closerapp.in to get your access.
                        </DialogContentText>
                    </DialogContent>
                </Box>
            </Dialog>}
            <div style={{ flexBasis: '25%', position: "sticky", height: "100%", maxHeight: "calc(100vh - 80px)", overflowY: "auto" }}>
                <div style={{ height: "75px", background: "#F8FCDB", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "0 10px" }}>
                    <Typography style={{ width: "100px", fontWeight: 600 }}>Filter By</Typography>
                    <div style={{ display: viewSaveFilter }}>
                        <Button onClick={handleOpenSavedFilters} disableElevation variant="contained" style={{ display: "flex", alignItems: "center", padding: "5px 10px", marginLeft: "auto", width: "fit-content", fontSize: "10px", backgroundColor: "#F8FCDB", color: 'black', border: "1px solid black" }} >
                            <span style={{ fontSize: "12px", fontWeight: 800 }}>View Saved Filters</span>
                        </Button>
                    </div>
                    <Modal
                        open={openSavedFilters}
                        onClose={handleCloseSavedFilters}
                    >
                        <Slide direction="left" in={openSavedFilters} mountOnEnter unmountOnExit timeout={300}>
                            <Box sx={savedFilterStyles}>
                                <SavedFilters handleClose={handleCloseSavedFilters} userData={userData} getSavedFilters={setSavedFilters} />
                            </Box>
                        </Slide>
                    </Modal>
                    <div style={{ display: clearFilter }}>
                        <Button disableElevation variant="contained" style={{ display: "flex", alignItems: "center", padding: "5px 10px", marginLeft: "auto", width: "fit-content", fontSize: "10px", backgroundColor: "#000000", color: 'white', borderRadius: "20px" }} onClick={handleClearFilter}>
                            <span style={{ fontSize: "12px", fontWeight: 800 }}>Clear All</span>
                            <ClearIcon fontSize='small' sx={{ marginBottom: "2px" }} />
                        </Button>
                    </div>
                </div>
                {filters.map((value, index) => (
                    <div style={{ borderTop: "1px solid #C4C4C4" }} key={index}>
                        <Accordion expanded={expandedAccordions[index]} onClick={() => handleAccordionExpand(index)} style={{ boxShadow: "none", zIndex: filters.length - index }}>
                            <StyledAccordionSummary
                                expandIcon={<AddIcon />}
                                style={{ display: "flex" }}
                                key={value}
                            >
                                <Grid container>
                                    <Grid item xs={12} style={{ display: "flex", gap: "10px" }}>
                                        <Typography component="div">
                                            <Box sx={{ fontWeight: "regular" }}>{value}</Box>
                                        </Typography>
                                        <Typography style={{ color: "#CDCDCD" }}>({filterKeys[index].length} of {filterLimits[index]} selected)</Typography>
                                    </Grid>
                                    {value == "Remove Viewed Influencers" && displayRemoveViewed && <div style={{ color: "red" }}>
                                        {/* <Typography>Please select atleast 2 filters before applying this</Typography> */}
                                        <Tooltip title={<React.Fragment>
                                            <Typography >Please select atleast 2 filters before applying this.</Typography>
                                        </React.Fragment>}>
                                            <InfoIcon sx={{ color: "black" }} />
                                        </Tooltip>
                                    </div>}
                                    {/* <Grid item xs={12} style={{ display: categoryDisplay }}>
                                            {filterKeys[index].map((value) => (
                                                <Chip key={value} label={value} style={{ background: "#E4F87F", margin: "5px" }} />
                                            ))}
                                        </Grid> */}
                                    <Box style={{ margin: "0px 15px 0px 0px" }}>
                                        {filterKeys[index].map((fkValue, fkIndex) => (
                                            <Button key={fkIndex} onClick={(event) => { event.stopPropagation(); removeSelection(fkValue, filterKeys[index], index) }} style={{ margin: "5px 5px 5px 0px", padding: "0px 10px 0px 10px", borderRadius: "20px", fontSize: "12px", background: "#E4F87F", color: "black", gap: "5px" }}>
                                                <span style={{ fontSize: "1em", fontWeight: 800 }}>{fkValue}</span>
                                                <ClearIcon style={{ fontSize: "1.6em" }} />
                                            </Button>
                                        ))}
                                    </Box>
                                </Grid>
                            </StyledAccordionSummary>
                            <AccordionDetails style={{ boxShadow: "0 12px 12px rgba(0,0,0,.2)", padding: "0px 10px 0px 10px", overflowY: "auto", maxHeight: "140px" }}>
                                <div style={{}}>
                                    {/* <FormControl sx={{ width: "100%" }}> */}
                                    <List style={{ padding: "0px 0px 0px 10px" }}>
                                        {/* {selectedButtons.includes(fv) && <Chip label={fv} variant="outlined" />} */}
                                        {value == "Brands worked with" && <div onClick={(event) => { event.stopPropagation() }}>
                                            <Autocomplete
                                                style={{ marginBottom: "20px" }}
                                                freeSolo
                                                options={filterValues[4]}
                                                getOptionLabel={(option) => option}
                                                sx={{ width: 300 }}
                                                renderInput={(params) => <TextField {...params} label="Search Brands" />}
                                                onChange={(_, value) => { handleAutocomplete(value) }}
                                            />
                                        </div>}
                                        {value != "Brands worked with" && value != "Remove Viewed Influencers" && filterValues[index].map((fv, i) => (
                                            <ListItem style={{ padding: "0px", margin: "0px" }} key={i}>
                                                <ListItemButton style={{ padding: "0px" }}
                                                    onClick={(event) => { event.stopPropagation(); handleButtonClick(fv, value) }}
                                                    selected={getFilterStateArray(value).includes(fv)}
                                                >
                                                    <ListItemText primary={fv} style={{ padding: "0px" }} />
                                                </ListItemButton>
                                            </ListItem>
                                        ))}
                                        {value == "Remove Viewed Influencers" && filterValues[index].map((fv, i) => (
                                            <ListItem style={{ padding: "0px", margin: "0px" }} key={i}>
                                                <ListItemButton style={{ padding: "0px" }}
                                                    disabled={displayRemoveViewed}
                                                    onClick={(event) => { event.stopPropagation(); handleButtonClick(fv, value) }}
                                                    selected={getFilterStateArray(value).includes(fv)}
                                                >
                                                    <ListItemText primary={fv} style={{ padding: "0px" }} />
                                                </ListItemButton>
                                            </ListItem>
                                        ))}
                                    </List>
                                </div>
                            </AccordionDetails>
                        </Accordion>
                    </div>
                ))}
                <div style={{ height: "90px", borderTop: "1px solid #C4C4C4", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Button disableElevation variant="contained" size="large" style={{ backgroundColor: "#E4F87F", color: 'black', width: "70%", borderRadius: "20px" }} onClick={handleOpenButtonSavedFilters}>
                        SAVE FILTER
                    </Button>
                    <Modal
                        open={openButtonSavedFilters}
                        onClose={handleCloseButtonSavedFilters}
                    >
                        <Box sx={{
                            position: 'absolute',
                            transform: 'translate(-50%, -50%)',
                            top: '50%',
                            left: '50%',
                            width: "30%",
                            boxShadow: 24,
                            borderRadius: "10px",
                            p: 3,
                            backgroundColor: "white",
                            maxHeight: "200px",
                            height: "150px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            gap: "10px"
                        }}>
                            <Box sx={{ paddingLeft: "15px" }}>
                                <Typography variant="h6">Save Applied Filters</Typography>
                            </Box>
                            <Box sx={{ width: "100%", display: "flex", justifyContent: "space-between", padding: "0px 15px 0px 15px" }}>
                                <TextField
                                    style={{ width: "70%", }}
                                    required
                                    placeholder="Enter Filter Name"
                                    value={filterName}
                                    onChange={handleFilterName}
                                />
                                <Button sx={{ border: "1px solid black", background: "#E4F87F", color: "black", width: "25%" }} onClick={() => saveAppliedFilters()}>{saveFilterCta}</Button>
                            </Box>
                        </Box>
                    </Modal>
                </ div>
            </div>
            <div style={lineStyles}></div>
            <div style={{ flexBasis: '75%' }}>
                <div style={{ padding: "10px", overflow: "auto" }}>
                    <Grid container >
                        <Grid item xs={8} style={{ display: "flex", alignItems: "center", justifyContent: "left" }}>
                            {/* <Button endIcon={clearYouTubeFilter && <ClearIcon fontSize='small' sx={{ color: "black" }} />} variant="elevated" sx={youtuberStyle} onClick={() => handleIsYouTuber()}>Has Youtube channel</Button> */}
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                                <Checkbox checked={checkedAll} onClick={selectAll} />
                                <Typography>Select all</Typography>
                            </Box>
                            {checked.length > 0 && <Button variant="elevated" sx={{ background: "#E4F87F", border: "1px solid #C4C4C4", color: "black", borderRadius: "20px", fontSize: "12px", margin: "0px 10px 0px 10px" }} onClick={handleOpenList}>Add to list</Button>}
                            {checked.length > 0 && <Typography>{checked.length} influencers selected</Typography>}
                        </Grid>
                        <Modal
                            open={openList}
                            onClose={handleCloseList}
                        >
                            <Box>
                                <DisplayListsDiscovery influencers={checked} handleClose={handleCloseList} userData={userData} />
                            </Box>
                        </Modal>
                        <Grid item xs={4} style={{ padding: "10px", display: "flex", justifyContent: "right", alignItems: "end" }}>
                            <Typography>Showing {totalDocs} results</Typography>
                        </Grid>
                    </Grid>
                    {isLoading && <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}><Box style={{ width: "fit-content", display: "flex", flexDirection: "column", alignItems: "center", gap: "20px" }}><CircularProgress style={{ color: "#E4F87F", }} size={100} />Loading...</Box></div>}
                    {!isLoading &&
                        <div>
                            <div style={gridContainerStyles}>
                                {influencers.slice((page - 1) * 100, page * 100).map((value, index) => (
                                    <InfluencerMinDetails key={index} influencer={value} userData={userData} checkedInfluencer={checkedMap.get(value.username) || false} handleToggle={handleToggle} />
                                ))}
                            </div>
                            <div style={{ display: displayPagination }}>
                                <div style={{ display: "flex", justifyContent: "center" }}>
                                    <div style={{ width: "50%", display: "flex", justifyContent: "center", alignItems: "center", marginTop: "20px", padding: "10px", color: "black", borderRadius: "20px" }}>
                                        <Pagination count={Math.ceil(totalDocs / 100)} page={page} color='standard' shape='rounded' onChange={handleChange} />
                                    </div>
                                </div>
                            </div>
                            <div style={{ display: displayNoPage }}>
                                <div style={{ display: "flex", justifyContent: "center", }}>
                                    <Box
                                        component="img"
                                        sx={{
                                            height: "490px",
                                            width: "370px",
                                        }}
                                        alt="Discovery No Results"
                                        src={DiscoveryNoResults}
                                    />
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
}

export default Discovery;
